import './styles/app.scss';
import app from './app';

angular.element(document).ready(function () {
    angular.bootstrap(document, [app.name], {
        strictDi: true
    });
});



// WEBPACK FOOTER //
// ./frontend/admin/index.js